<!--This file is part of sisdai-proyecto-base.-->

<!--sisdai-proyecto-base is free software: you can redistribute it and/or modify-->
<!--it under the terms of the GNU Lesser General Public License as published by the-->
<!--Free Software Foundation, either version 3 of the License, or-->
<!--(at your option) any later version.-->

<!--sisdai-proyecto-base is distributed in the hope that it will be useful,-->
<!--but WITHOUT ANY WARRANTY; without even the implied warranty of-->
<!--MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General-->
<!--Public License for more details.-->

<!--You should have received a copy of the GNU Lesser General Public License along-->
<!--with sisdai-proyecto-base. If not, see <https://www.gnu.org/licenses/>.-->

<script setup>
import { onBeforeUnmount, onMounted } from 'vue'
import MapaPueblosContexto from '@/components/mapas/MapaPueblosContexto.vue'
import PaginaMapasPoblacion from './mapas/PaginaMapasPoblacion.vue'

function calHeight() {
  const innerheight = window.innerHeight / 100
  document
    .querySelector(':root')
    .style.setProperty('--vh', `${innerheight.toString()}px`)
}

calHeight()

onMounted(() => {
  window.addEventListener('resize', calHeight)
})

onBeforeUnmount(() => {
  window.addEventListener('resize', calHeight)
})

const cdnArchivos = process.env.VUE_APP_CDN_ARCHIVOS
</script>

<template>
  <main id="principal">
    <div class="contenedor-portada">
      <picture>
        <source
          :srcset="`${cdnArchivos}/portada/inicio.webp`"
          type="image/webp"
        />
        <source
          type="image/jpg"
          :srcset="`${cdnArchivos}/portada/inicio.jpg`"
        />
        <img
          class="portada"
          loading="lazy"
          :src="`${cdnArchivos}/portada/inicio.jpg`"
        />
      </picture>
      <div class="degradado-negro-abajo">
        <div class="contenido-abajo">
          <div class="contenedor ancho-fijo">
            <h1 class="titulo-capitulo texto-centrado texto-color-1">
              Pueblos y Comunidades Indígenas y Afromexicanas
            </h1>
          </div>
          <div class="contenedor ancho-lectura">
            <h2 class="subtitulo-capitulo texto-centrado texto-color-1">
              Un capítulo del Ecosistema Nacional Informático de Cultura
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="contenedor ancho-lectura m-y-10">
      <p>
        Este capítulo se desarrolló con el apoyo del Instituto Nacional de los
        Pueblos Indígenas que proporcionó información sobre la población
        indígena y afromexicana. Además de consultar los mapas interactivos
        puedes explorar por separado las capas geográficas en
        <SisdaiEnlaceExterno
          enlace="https://gema.conahcyt.mx/visualizador?capas=pciaf_pob_indigena_asent_hist_20_loc_p,,1%3Bpciaf_pob_indigena_residentes_20_loc_p,,1%3Bpciaf_casas_comedores_ninez_ind_21_xy_p,,1%3Bpciaf_radiodifusoras_ind_160124_xy_p,,1%3Bpciaf_oficinas_repre_inpi_160124_xy_p,,1%3Bpciaf_centros_coord_pue_ind_160124_xy_p,,1%3Bsalu_unidades_medicas_3n_clues_21_xy_p,,1%3Bsalu_unidades_medicas_2n_clues_21_xy_p,,1%3Bsalu_unidades_medicas_1n_clues_21_xy_p,,1%3Beduc_establecimientos_escolares_15_xy_p,,1%3Bgref_corredores_red_nac_caminos_21_nal_l,,1%3Bpciaf_pob_ind_nucleos_agrarios_21_nal_a,,1%3Bpciaf_territorios_pueb_indig_07_nal_a,,1#map=5/23.6254/-102.5378"
          texto="Gema"
        />.
      </p>
    </div>

    <!-- <PaginaMapas /> -->
    <div class="contenedor ancho-fijo">
      <MapaPueblosContexto />

      <PaginaMapasPoblacion class="m-y-6" />
    </div>
  </main>
</template>
